import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import EventBus from './EventBus';

import * as firebase from 'firebase/app';
import 'firebase/auth';

Vue.config.productionTip = false;

const firebaseConfig = {
    apiKey: 'AIzaSyAimwfJUXYieK89zY1Ue3_CIqxFmjYIl4o',
    authDomain: 'savvysuit-probono.firebaseapp.com',
    databaseURL: 'https://savvysuit-probono.firebaseio.com',
    projectId: 'savvysuit-probono',
    storageBucket: 'savvysuit-probono.appspot.com',
    messagingSenderId: '235877176927',
    appId: '1:235877176927:web:8a0d8e23b3065f5081adea',
};

const currentRouter = router;

new Vue({
    router,
    store,
    data: () => {
        return {
            userLoginStatus: false,
        };
    },
    methods: {
        logoutUser() {
            if (
                (window.location.pathname !== '/privacy') &&
                (window.location.pathname !== '/terms-of-service')
            ) {
                currentRouter.push({
                    name: 'authentication',
                });
            }

            firebase.auth().signOut()
                .then(() => {
                    EventBus.$emit('UserLoggedOut');

                    currentRouter.push({
                        name: 'authentication',
                    });

                    console.log(`User logged out successfully`);
                })
                .catch((error) => {
                    console.log(`Unable to logout user: `, error.toString());
                });
        },
        startLoginFlow() {
            currentRouter.push({
                name: 'authentication',
            });
        },
        forceLogInUser() {
            console.log(`Received request to force user to login page.`);
            this.checkUserAuthState(true);
        },
        checkUserAuthState(forceLogin: boolean = false) {
            const startLoginFlowFcn = this.startLoginFlow;

            console.log(`Current route: ${window.location.pathname}`);

            firebase.auth().onAuthStateChanged((user: any) => {
                if (user) {
                    EventBus.$emit('UserLoggedIn');
                    this.userLoginStatus = true;
                    console.log(`User has successfully authenticated.`);
                } else {
                    if (forceLogin) {
                        this.userLoginStatus = false;

                        EventBus.$emit('UserLoggedOut');

                        console.log(`Forcing navigating to authentication.`);

                        startLoginFlowFcn();
                    } else {
                        if (
                            (window.location.pathname !== '/privacy') &&
                            (window.location.pathname !== '/terms-of-service') &&
                            (window.location.pathname !== '/authentication') &&
                            (window.location.pathname !== '/')
                        ) {
                            startLoginFlowFcn();
                        } else {
                            console.log(`Ignoring login request as not forced nor on a restricted page.`);
                        }
                    }
                }
            });
        },
    },
    created() {
        firebase.initializeApp(firebaseConfig);

        firebase.auth().useDeviceLanguage();

        EventBus.$on('ForceLogInUser', this.forceLogInUser);
        EventBus.$on('LogInUser', this.checkUserAuthState);
        EventBus.$on('LogOutUser', this.logoutUser);

        this.checkUserAuthState();
    },
    render: (h) => h(App),
}).$mount('#app');
